import { useEffect } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { getToken } from '../../services/tokenService';
import { API } from './constants';

const fr = (d) => (d ? d.split('-').reverse().join('/') : '');

// ?prolonger=<souscription_id> : nouvelle période nominative du même chantier (MO, activités, CA repris ; jours à saisir).
export function useProlongationPrefill({
  location, autoCalcDoneRef, setFormData, setModeCalcul, setMembreData, setOperationNominative,
  setSelectedActivitesGO, setSelectedActivites2nd, setSelectedActivitesTP, setSelectedActivitesPIB,
}) {
  useEffect(() => {
    const qs = new URLSearchParams(location.search);
    const renouveler = qs.get('renouveler');
    const id = qs.get('prolonger') || renouveler;
    if (!id) return undefined;
    let cancelled = false;
    (async () => {
      try {
        const { data } = await axios.get(`${API}/maitres-ouvrage/prolongation/${encodeURIComponent(id)}`, {
          headers: { Authorization: `Bearer ${getToken()}` },
        });
        if (cancelled) return;
        if (autoCalcDoneRef) autoCalcDoneRef.current = false;
        const nominative = !renouveler || data.nominative;
        setModeCalcul(nominative ? 'nominative' : 'annuel');
        setFormData((prev) => ({
          ...prev, ca_ht: data.ca_ht ? String(Math.round(Number(data.ca_ht))) : prev.ca_ht, nombre_jours: nominative ? '' : prev.nombre_jours,
          maitre_ouvrage: { ...data.maitre_ouvrage, type: ['particulier', 'personne_physique'].includes(data.maitre_ouvrage?.type) ? 'particulier' : 'professionnel' },
        }));
        setOperationNominative((prev) => ({ ...prev, ...data.operation_nominative }));
        if (data.membre_prefill?.membre_id) setMembreData((prev) => ({ ...(prev || {}), ...data.membre_prefill }));
        const det = data.activites_details || {};
        const sel = data.activites_selectionnees || {};
        const ids = (k) => {
          const d = (det[k] || []).map((a) => a?.id).filter(Boolean);
          return d.length ? d : (Array.isArray(sel[k]) ? sel[k] : []);
        };
        [['gros_oeuvre', setSelectedActivitesGO], ['second_oeuvre', setSelectedActivites2nd], ['travaux_publics', setSelectedActivitesTP], ['pib', setSelectedActivitesPIB]]
          .forEach(([k, set]) => { const v = ids(k); if (v.length) set(v); });
        if (renouveler) {
          toast.info('Renouvellement de la souscription', {
            description: `${data.numero_police}${data.fin_couverture ? ` — expire le ${fr(data.fin_couverture)} ; la nouvelle période du devis démarrera le ${new Date(new Date(data.fin_couverture).getTime() + 86400000).toLocaleDateString('fr-FR')}` : ''}. Activités et chiffre d'affaires repris : vérifiez puis générez le nouveau devis.`,
            duration: 9000,
          });
          return;
        }
        toast.info('Prolongation du chantier', {
          description: `${data.numero_police}${data.fin_couverture ? ` — couverture actuelle jusqu'au ${fr(data.fin_couverture)}` : ''}. Indiquez le nombre de jours supplémentaires puis lancez le calcul.`,
          duration: 9000,
        });
      } catch (e) {
        if (!cancelled) toast.warning('Chantier introuvable', { description: 'Renseignez la simulation nominative manuellement.' });
      }
    })();
    return () => { cancelled = true; };
  }, [location.search]); // eslint-disable-line react-hooks/exhaustive-deps
}
